module.exports = __webpack_public_path__ + "static/media/logo_footer.d8ebfa05.svg";